import { UPDATE_MESSAGES } from "Redux/Actions/messagesActions.js";

const INITIAL_STATE = {
  myConversations: [],
  currentConversation: null,
  newId: 1,
  openId: 2,
};

const messagesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_MESSAGES: {
      return {
        ...state,
        ...action.value,
      };
    }
    default:
      return state;
  }
};

export default messagesReducer;
